import { HeaderMain, HeaderParagraph, HeaderTitle } from "./HeaderElements";
import { Container, Column2 } from "./../Layout/layoutElement";
import Img from "./../image/img";
import MainButton from "./../button/MainButton";
import { PORTAL_BASE_URL } from "../../constants/defaultValues";

export default function Header() {
  return (
    <HeaderMain>
      <Container>
        <Column2 divide={2}>
          <HeaderTitle>Make Swift & seamless payments</HeaderTitle>
          <HeaderParagraph>
            We are your one-stop payment service for payment collections and
            disbursement with the widest choice of payment methods and schemes
            to support your organization and make transactions easier.
          </HeaderParagraph>
          {/* <a href={`${PORTAL_BASE_URL}/user/register`} target="_blank" rel="noreferrer"> */}
          <a href={`/register`} rel="noreferrer">
          <MainButton text={`Register`} main={true} />
          </a>
        </Column2>
        <Column2 divide={2}>
          <Img alt={"picture one"} />
        </Column2>
      </Container>
    </HeaderMain>
  );
}
